export const formatCurrency = (value) => {
  return Number(value).toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
};
